export default __webpack_public_path__ + "static/media/ava-06.5e81a6f8.png";